import * as e from "react";
import { forwardRef as t } from "react";
const a = t(function(o, r) {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      fill: "none",
      ref: r,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...o
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M19 10.8571H16.6667V8.57143C16.6667 6.04663 14.5774 4 12 4C9.4226 4 7.33333 6.04663 7.33333 8.57143V10.8571H5V20H19V10.8571ZM14.3333 10.8571H9.66667V8.57143C9.66667 7.30903 10.7113 6.28571 12 6.28571C13.2887 6.28571 14.3333 7.30903 14.3333 8.57143V10.8571Z",
        fill: "currentColor"
      }
    )
  );
});
export {
  a as Padlock
};
